module.exports = __webpack_public_path__ + "img/00127047329117.eaee9099.png";